<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

            </div>
        </div>
        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4 class="font-regular with-blue-text">Current Selected: <span>Monthly Payroll Report</span></h4>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                    <div class="d-inline-block">
                        <b-form-select v-model="fiscal_year">
                            <b-form-select-option value="">Select Fiscal Year</b-form-select-option>
                            <b-form-select-option v-for="(data, n) in payroll_reporting_data" :key="n" :value="data.fiscal_year">{{data.fiscal_year}}</b-form-select-option>
                        </b-form-select>
                    </div>

                    <div class="d-inline-block trz_fields trz-custom-dropdown ml-2" >
                        <b-dropdown id="dropdown-fields" text="Select Additional Fields" ref="dropdown" class=" position-relative">
                            <b-dropdown-form>
                                <b-form-group @submit.stop.prevent>
                                    <div class="form-group">
                                        <b-form-checkbox-group
                                            v-model="column_selected"
                                            :options="column_options"
                                            switches

                                        />
                                    </div>
                                    <button type="button" @click="setcolumn()" class="btn btn-primary d-none">Save</button>
                                </b-form-group>
                            </b-dropdown-form>
                        </b-dropdown>
                        <!-- <div class="d-inline-block pt-2 px-0 ml-3">{{show_selected}} {{clickSelect}}</div> -->
                    </div>
                    {{clickSelect}}
                    <div class="d-inline-block report-selected-columns mt-3" v-if="column_selected_view.length > 0"> <span class="font-semi-bold text-secondary py-1 px-2 bg-white rounded" v-for="column in column_selected_view">{{ stringView(column) }}</span></div>

                    <div class="d-inline-block float-right ml-2 mb-3">
                        <b-button class="text-right" @click="showReportSettings()">
                            <i class="fa fa-cog" aria-hidden="true"></i>
                            Settings
                            <span class='beta-font'>(beta)</span>
                        </b-button>
                    </div>

                </div>
            </div>
            <!-- <employee-fields ></employee-fields> -->
            <div class="ibox col-md-12">
                <div class="ibox-content px-0 pt-3">
                    <table v-for="(data, n) in payroll_reporting_data" v-if="data.fiscal_year == fiscal_year" class="table" :key="n">
                        <thead>
                            <tr class="table-head">
                            <th scope="col">Month - Year</th>
                            <th scope="col">Fiscal Year</th>
                            <th scope="col">Payrun Status</th>
                            <th scope="col">Preview Report</th>
                            <th scope="col">Download Report</th>
                            <th scope="col" v-if="customized_payroll_report_status == '1'">Download Custom Report</th>
                            <!-- Sohel: New mappings update -->
                            <th scope="col" v-if="cost_center_number > 0">Download Report with Cost Centers</th>
                            <!-- Sohel: New mappings update -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="display: none;"></tr>
                            <!-- <tr class="table-row hover-bg" v-for="(month, n) in data.month" :key="n" >                         -->
                            <tr class="table-row hover-bg" v-for="(month, ordering) in sortArrays(data.month)"  :key="ordering" >
                                <td>{{month.name}} -  {{year_from_fiscal_year_month_val(month.value,data.fiscal_year)}}</td>
                                <td>{{data.fiscal_year}}</td>
                                <td>{{month.status}}</td>
                                <td><a href="#" @click="viewDetails(fiscal_year, month.value)"> <i class="fas fa-list"> </i> Preview Report</a></td>
                                <td><a href="#" @click="getSalaryReport(fiscal_year,month.value,'regular_report')"><i class="far fa-file-excel"> </i> Download Report (Excel)</a></td>
                                <td v-if="customized_payroll_report_status == '1'"><a href="#" @click="getSalaryReport(fiscal_year,month.value,'customized_report')"><i class="far fa-file-excel"> </i> Download Custom Report (Excel)</a></td>
                                <!-- Sohel: New mappings update -->
                                <td v-if="cost_center_number > 0"><a href="#" @click="getSalaryReport(fiscal_year,month.value,'cost_center_report')"><i class="far fa-file-excel"> </i> Download Report with Cost Centers (Excel)</a></td>
                                <!-- Sohel: New mappings update -->
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        <b-modal id="monthly-payroll-report" dialog-class="modal-xxl" size="xl" scrollable  hide-footer title="Monthly Payroll Report">
            <b-overlay  rounded="sm">
                <div class="clearfix row py-2 mb-2">
                    <div class="col-md-6 px-3 company-form-box-title">{{d_month}} - {{d_year}}</div>
                    <div class="col-md-6">
                        <b-input-group class="mb-0 custom-search ml-auto mr-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>

                <table class="table ">
                    <thead class="" style="">
                        <tr class="table-head"  v-for="(detail, index) in paginatedData" :key="detail.employee_ID">
                            <template v-if="index < 1">
                                <td class="text-center" v-for="(v,i,count) in detail"><template v-if="i == 'gross_pay'">Total Earnings</template><template v-else>{{ replaceTableHeads(i) }}</template></td>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="display: none;"></tr>
                        <tr class="table-row hover-bg " v-for="detail in paginatedData" :key="detail.employee_ID">
                            <!--aboni 10-11-21-->
                            <template v-for="(v,i,count) in detail">
                                <td v-if="column_selected.indexOf(stringViewReverse(i)) !== -1 || column_selected.indexOf(i) !== -1">{{v}}</td>
                                <td v-else-if="i == 'Name Of Employee' || i == 'Job Position'">{{v}}</td>
                                <td v-else class="text-right">{{v}}</td>
                            </template>
                            <!--aboni 10-11-21-->


                        </tr>
                    </tbody>
                </table>
                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell text-center">
                    <span class="d-block text-center">{{empty_result}}</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div v-else class="px-3"><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav></div>
            </b-overlay>
        </b-modal>

        <b-modal id="monthly-payroll-report-settings" no-close-on-backdrop   dialog-class="modal-md" size="md" scrollable  hide-footer title="Monthly Payroll Report Settings">
            <b-overlay  rounded="sm">

                <b-form>


                    <b-form-group id="show_break_down"  label="Show Breakdown Based on:" label-for="show_break_down">
                        <b-form-radio  name="show_break_down" v-model="report_settings.show_break_down"   value='none'>None</b-form-radio>
                        <b-form-radio name="show_break_down" v-model="report_settings.show_break_down" value='department'>Department</b-form-radio>
                        <b-form-radio name="show_break_down" v-model="report_settings.show_break_down" value='jobposition'>Designation</b-form-radio>
                        <b-form-radio name="show_break_down" v-model="report_settings.show_break_down" value='branch'>Work Location</b-form-radio>

                        <template v-if="costcenters.length > 0">
                            <b-form-radio name="show_break_down" v-model="report_settings.show_break_down" value='cost_center'>Cost Center</b-form-radio>
                        </template>
                    </b-form-group>
                    <div id='extra_field_group' class='clearfix'>
                          <!-- alpha fix- chnaged icon here  -->
                        <div class="row"><div class="col-sm-6 text-left pr-0 mt-1">Extra Fields</div> <div class="col-sm-6 text-right pr-2 mt-1"><b-button class="cmp-block-btn ek-show-btn" id="show-btn" @click="showModal('Extra Fields')" variant="primary"><b-icon icon="plus" class="align-left"></b-icon>Add</b-button></div></div>
                        <b-form-group label="" id="extra_field_group_from" class = 'float-left  mb-0 clearfix'>
                            <b-form-checkbox-group
                                v-model="extra_fields"
                                name="extra_fields"
                                stacked>
                                <template v-for="(row, index) in extra_fields_options">
                                    <b-form-checkbox :value="row.title">{{row.title}}</b-form-checkbox>
                                </template>
                            </b-form-checkbox-group>
                        </b-form-group>
                        <div class="col-sm-6 float-right text-right pr-0 mt-1 mb-2 clearfix">
                            <template v-for="(row, index) in extra_fields_options">
                                <div class="cmp-child-items text-right" style='width:100% !important;'>
                                    <b-icon class="delete-btn-red" @click="removeEntry('Extra Fields',index)" icon="trash-fill" role="button" aria-hidden="true" scale="1.2" ></b-icon>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div id='extra_signature_field_group' class='clearfix'>

                        <!-- alpha fix- chnaged icon here  -->
                        <div class="row"><div class="col-sm-6 text-left pr-0 mt-1">Signature Fields</div> <div class="col-sm-6 text-right pr-2 mt-1"><b-button class="cmp-block-btn ek-show-btn" id="show-btn" @click="showModal('Signature Fields')" variant="primary"><b-icon icon="plus" class="align-left"></b-icon>Add</b-button></div></div>
                        <b-form-group label="" class = 'float-left clearfix'>
                        <b-form-checkbox-group
                            v-model="extra_signature_fields"
                            name="extra_signature_fields"
                            stacked
                        >
                        <template v-for="(row, index) in extra_signature_fields_options">
                                <b-form-checkbox :value="row.title">{{row.title}}</b-form-checkbox>
                        </template>
                        </b-form-checkbox-group>
                        </b-form-group>

                        <div class="col-sm-6 float-right text-right pr-0 mt-1 mb-2 clearfix">
                            <template v-for="(row, index) in extra_signature_fields_options">
                                <div class="cmp-child-items text-right" style='width:100% !important;'>
                                    <b-icon class="delete-btn-red" @click="removeEntry('Signature Fields',index)" icon="trash-fill" role="button" aria-hidden="true" scale="1.2" ></b-icon>
                                </div>
                            </template>

                        </div>
                    </div>

                    <!-- <b-form-group id="loan_id-group"  v-bind:label="company_id_title" label-for="loan_id">
                        <b-form-input id="loan_id" name="loan_id" :disabled="disableme" v-model="fdata.company_loan_id" v-validate="{ min: 5 }" :state="validateState('loan_id')" aria-describedby="loan_id-feedback" data-vv-as="Company Loan/Advance ID"></b-form-input>
                        <b-form-invalid-feedback id="loan_id-feedback">{{ veeErrors.first('loan_id') }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="loan_amount-group" v-bind:label="amount_title" label-for="loan_amount">
                        <b-form-input id="loan_amount"  name="loan_amount" :disabled="disableamount" v-model="fdata.loan_amount" v-validate="{ required: true }" :state="validateState('loan_amount')" aria-describedby="loan_amount-feedback" data-vv-as="Loan/Advance Amount"></b-form-input>
                        <b-form-invalid-feedback id="loan_amount-feedback">{{ veeErrors.first('loan_amount') }}</b-form-invalid-feedback>
                        <div class="invalid-feedback" style="display:block !important;" v-if="this.pf_loan_form_disable==true">The Loan Amount must be less or equal to Total Provodent Fund Balance</div>
                        <div style="min-height:30px;">
                            <div v-show="disable_submit_amount==true" class="mb-1"  style="font-size: 80% !important; color: #e3342f !important" id="submit-disable">Loan amount is invalid</div>
                        </div>
                    </b-form-group>

                    <b-form-group id="paid_amount-group" v-bind:label="paid_amount_title" label-for="paid_amount" v-show="edit_form==1 && disableamount == true">
                        <b-form-input id="paid_amount"  name="paid_amount" :disabled="disableme" v-model="fdata.paid_amount" ></b-form-input>
                    </b-form-group>

                    <b-form-group id="remaining_amount-group" v-bind:label="remaining_amount_title" label-for="remaining_amount" v-show="edit_form==1 && disableamount == true">
                        <b-form-input id="remaining_amount"  name="remaining_amount" :disabled="disableme" v-model="fdata.remaining_amount" ></b-form-input>
                    </b-form-group> -->


                    <!-- alpha fix- added col-md-12 and text center  -->
                    <div class="col-md-12 text-center mt-2">
                        <b-button class="cmp-block-btn ek-show-btn" id="show-btn" @click="onSave()" variant="primary">Save</b-button>
                    </div>


                </b-form>

            </b-overlay>
        </b-modal>

        <b-modal id="bv-modal-add-new-component" hide-footer :title="popup_title">

            <b-form @submit.stop.prevent="onSubmit">
                <b-overlay :show="tt_loader" rounded="sm">
                    <b-form-group id="component_title-group">
                        <label class="d-block" for="Title">{{fdata.label_component}}</label>

                        <b-form-input id="component_title" name="Title" v-model="fdata.component_title" v-validate="{ required: true}" :state="validateState('Title')"></b-form-input>
                        <b-form-invalid-feedback id="component_title-feedback">{{ veeErrors.first('Title') }}</b-form-invalid-feedback>
                    </b-form-group>
                    <div class="full-width text-center" >
                        <b-button type="submit" variant="primary">Submit</b-button>
                        <b-button class="ml-2" variant="primary" @click="resetForm()">Reset</b-button>

                    </div>

                </b-overlay>
            </b-form>

        </b-modal>
    </div>
</template>

<script>


    export default{

        mounted() {
            this.$refs.trzcalendar;
        },
        //Sohel: New mappings update
        props: [ 'flag', 'customized_payroll_report_status', 'cost_center_number'],
        //Sohel: New mappings update
        components: {

        },
        data(){

            return {


                costcenters:[],
                search:'',
                length: 100,
                pagination: {currentPage: 1, pages:1},
                tt_loader:false,
                empty_result : 'Please hold tight! We are preparing the report data for you! ',

                fiscal_year : '',
                fiscal_month : '',
                d_month : '',
                d_year : '',
                showoverlay : true,
                loader: false,
                popup_title:'',

                payroll_reporting_data : [],
                details : [],
                monthArray:[],
                report_settings:{show_break_down:'none'},

                company_report_settings:{},

                /***Ali */

                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',
                extra_fields:[],
                extra_signature_fields:[],
                extra_fields_options: [],
                modal_type:'',
                extra_signature_fields_options: [],
                fdata: {component_title: '',btn_title:''}


            }
        },
        methods:{

            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');

                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    if(val[i].length == 2 && val[i] == 'pf'){
                        val[i] = val[i].toUpperCase();
                    }else{
                        val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);
                    }
                }
                return val.join(' ');
            },
            sortArrays(arrays) {
            return _.orderBy(arrays, 'ordering', 'desc');
        },
            year_from_fiscal_year_month_val(month_val,fiscal_year){
                 var year_array = [];
                year_array = fiscal_year.split('-');
                if(month_val > 6 && month_val <=12){
                        return year_array[0];
                }else{
                      return year_array[1];
                }

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            showModal(title)
            {
                this.modal_type = '';
                this.popup_title = 'Add '+title;
                this.modal_type = title;
                this.fdata.component_title = '';

                 if(title == 'Extra Fields')
                    this.fdata.label_component = 'Name of Extra Field *';
                else if(title == 'Signature Fields')
                    this.fdata.label_component = 'Name of Signature Field *';
                this.$bvModal.show('bv-modal-add-new-component');


            },
            resetForm()
            {
                this.fdata.component_title = '';
            },
            showReportSettings: function()
            {
                this.$bvModal.show('monthly-payroll-report-settings');
            },
            getPayrollReporting: function()
            {
                if(!this.checkNet()) return false;
                // axios.get(this.$api_url+'/report/payrollreportingyearly' , {
                axios.get(this.$api_url+'/report/payrollreporting' , {
                    params: {

                    }
                }).then(function(response){
                    // this.payroll_reporting_data = response.data;
                    this.payroll_reporting_data = response.data;
                    //foreach
                    //month
                    // arry sort
                    // monthArray

                }.bind(this));
            },
            get_current_fiscal_year: function()
            {
                //
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/getcurrentfiscalyear' , {
                }).then(function(response){
                    this.fiscal_year= response.data;

                }.bind(this));
            },

            onSubmit: function()
            {

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                console.log(this.modal_type);
                let vl = {status:'0',title:this.fdata.component_title};
                if(this.modal_type=='Extra Fields')
                {
                    this.extra_fields_options.push(vl);
                }
                else if(this.modal_type=='Signature Fields')
                {
                    this.extra_signature_fields_options.push(vl);
                }
                this.$bvModal.hide('bv-modal-add-new-component');





                });

            },
            removeEntry: function(type,index)
            {
                if(type=='Extra Fields')
                {
                    this.extra_fields_options.splice(index, 1);
                }
                else if(type=='Signature Fields')
                {
                    this.extra_signature_fields_options.splice(index, 1);
                }
            },
            get_report_settings: function()
            {
                //
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/company/report-settings' , {
                }).then(function(response){

                    // console.log('/company/report-settings');
                    // console.log(response.data);
                    //this.fiscal_year= response.data;

                    this.company_report_settings = response.data;

                    this.report_settings.show_break_down = this.company_report_settings.show_break_down.value;


                    if(this.company_report_settings.extra_fields != null)
                    {
                        this.extra_fields_options = this.company_report_settings.extra_fields;
                        for (let i = 0, len = this.extra_fields_options.length, text = ""; i < len; i++)
                        {

                            if(this.extra_fields_options[i].status == '1')
                            {
                                this.extra_fields.push(this.extra_fields_options[i].title);
                            }

                            //console.log(this.extra_fields_options[i]);
                        }
                    }
                     if(this.company_report_settings.extra_signature_fields != null)
                    {
                        this.extra_signature_fields_options =  this.company_report_settings.extra_signature_fields;

                        for (let i = 0, len = this.extra_signature_fields_options.length, text = ""; i < len; i++) {

                            if(this.extra_signature_fields_options[i].status == '1')
                            {
                                this.extra_signature_fields.push(this.extra_signature_fields_options[i].title);
                            }
                        }


                    }

                    console.log(this.report_settings.extra_signature_fields);
                }.bind(this));
            },
            onSave: function(){

                for (let i = 0, len = this.extra_fields_options.length, text = ""; i < len; i++)
                {

                    if( this.extra_fields.includes(this.extra_fields_options[i].title) )
                    {
                        this.extra_fields_options[i].status = '1';
                    }
                    else
                    {
                        this.extra_fields_options[i].status = '0';
                    }

                    //console.log(this.extra_fields_options[i]);
                }

                for (let i = 0, len = this.extra_signature_fields_options.length, text = ""; i < len; i++)
                {

                    if( this.extra_signature_fields.includes(this.extra_signature_fields_options[i].title) )
                    {
                        this.extra_signature_fields_options[i].status = '1';
                    }
                    else
                    {
                        this.extra_signature_fields_options[i].status = '0';
                    }

                    //console.log(this.extra_fields_options[i]);
                }

                this.company_report_settings.show_break_down = {value:this.report_settings.show_break_down};
                this.company_report_settings.extra_fields = this.extra_fields_options;
                this.company_report_settings.extra_signature_fields = this.extra_signature_fields_options;

                console.log('company_report_settings');
                console.log(this.company_report_settings);

                console.log(this.extra_fields_options);
                console.log(this.extra_signature_fields_options);
                console.log(this.report_settings.show_break_down);

                var text = JSON.stringify(this.company_report_settings);

                console.log('stringify');
                console.log(text);


                let formData = new FormData();
                formData.append('report_settings', text);

                let currentObj = this;
                let url = this.$api_url + '/company/report-settings/save';
                axios.post(url, formData).then(function (response)
                {
                    console.log('company/report-settings/save');
                    console.log(response.data);
                    if(response.data==1)
                    {
                        this.$bvToast.toast("Saved!", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                    }
                    else
                    {
                        this.$bvToast.toast("Server Error!", {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                });

                    }


                }.bind(this)).catch(function (error){ currentObj.serverError(error);

                this.$bvToast.toast(error, {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                });

                });



            },
            viewDetails: function(year, month)
            {
                if(!this.checkNet()) return false;
                var months = ["", "January", "February", "March", "April", "May", "June",
           "July", "August", "September", "October", "November", "December" ];

                // this.fiscal_year = year;
                if(this.column_selected.indexOf('name') === -1){
                    this.column_selected.unshift('name');
                }
                this.fiscal_month = months[month];
                this.d_month = months[month];
                year = this.year_from_fiscal_year_month_val(month,year);
                this.d_year = year;
                this.details = [];
                let formData = new FormData();

                this.report_settings.extra_fields = this.extra_fields;
                this.report_settings.extra_signature_fields = this.extra_signature_fields;

                formData.append('year', year);
                formData.append('month', month);
                formData.append('report_name', 'mpr');
                formData.append('column_selected', this.column_selected);
                formData.append('show_break_down', this.report_settings.show_break_down);
                formData.append('extra_fields', this.report_settings.extra_fields);
                formData.append('extra_signature_fields', this.report_settings.extra_signature_fields);

                let url = this.$api_url + '/payroll-custom-report-data';

                let currentObj = this;
                axios.post(url, formData).then(function (response)
                {
                    this.empty_result = 'Please hold tight! We are preparing the report data for you!';
                    this.details = response.data;

                    if(this.details.length == 0)
                        this.empty_result = 'No Result Found!';

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});

                this.$bvModal.show('monthly-payroll-report');
                console.log(this.column_selected);


            },
            getSalaryReport: function(fiscal_year,month,flag)
            {
                let  year = this.year_from_fiscal_year_month_val(month,fiscal_year);
                if(!this.checkNet()) return false;
                this.loader = true;
                if(this.column_selected.indexOf('name') === -1){
                    this.column_selected.unshift('name');
                }
                let currentObj = this;
                let formData = new FormData();
                this.report_settings.extra_fields = this.extra_fields;
                this.report_settings.extra_signature_fields = this.extra_signature_fields;
                formData.append('year', year);
                formData.append('month', month);
                formData.append('grid_report', 'Excel');
                formData.append('column_selected', this.column_selected);
                formData.append('report', 1);
                formData.append('show_break_down', this.report_settings.show_break_down);
                formData.append('extra_fields', this.report_settings.extra_fields);
                formData.append('extra_signature_fields', this.report_settings.extra_signature_fields);
                const config = {
                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }
                let url = this.$api_url + '/payroll_monthly_report_custom?flag='+flag;
                axios.post(url, formData, config).then(function (response)
                {
                    //this.payroll_reporting_data = response.data;
                    //var fileURL = this.$api_url+'/payroll_monthly_report?grid_report=Excel&year='+year+'&month='+month;
                    //this.download_file(response.data);
                    this.loader = false;
                    if(response.data.type =='application/json'){
                        let file = new Blob([response.data], {type: 'application/json'});
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                            let err_obj = JSON.parse(`${value}`);
                            this.$bvToast.toast(err_obj.error_msg, {title: 'Error',variant: 'danger',solid: true});
                        });
                    }else{
                        this.global_download_file_content(response);
                    }

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
                return false;
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            getPayrollDefaultField()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/report/payrollreporting/defaultfields' , {
                }).then(function(response){
                    this.default_fields = response.data;
                    let available_colunms = [];

                    let co = [];
                    var txt = '';
                    this.default_fields.forEach(element => {

                        if(element=='etin')
                        {
                            txt = 'e-TIN';
                        }
                        else if(element=='jobposition')
                        {
                            txt = 'Job Position';
                        }
                        else if(element=='nid')
                        {
                            txt = 'NID';
                        }
                        else if(element=='branch')
                        {
                            txt = 'Work Location';
                        }
                        else
                        {
                            txt = this.stringView(element);
                        }
                        co = co.concat([{ text: txt , value: element }]);



                        available_colunms = available_colunms.concat(element);
                    });

                    this.column_options = this.column_options.concat(co);


                    // console.log('available_colunms');

                    // console.log(available_colunms);

                    // console.log('column_selected');

                    // console.log(this.column_selected);

                    let final_column_selected = [];
                    this.column_selected.forEach(element =>
                    {
                        if(available_colunms.includes(element))
                        {
                            // console.log('available_colunms_element');
                            // console.log(element);
                            final_column_selected.push(element);
                        }
                        else
                        {
                            // console.log('available_colunms_missing');
                            // console.log(element);
                            // //this.column_selected.splice(this.column_selected.lastIndexOf(element), 1);
                        }
                    });


                    // console.log('final_column_selected');
                    // console.log(final_column_selected);

                    this.column_selected = final_column_selected;

                    // console.log('column_selected');
                    // console.log(this.column_selected);

                }.bind(this));
            },
            stringView(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            stringViewReverse(str)
            {
                if(str == 'jobposition')
                    str = 'job_position';

                str = str.replace(/ /g,"_").toLowerCase();

                return str;
            },
            setcolumn: function()
            {
                this.$cookies.set("report_column_selected", this.column_selected);

                this.$refs.dropdown.hide(true);
            },
            convertToString()
            {
                this.column_selected_view.forEach(element =>
                {
                    this.column_selected_view.push(this.stringView(element));
                });
                return (this.column_selected_view.join(' , '));

            },

            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            },
            getAllCostCenters: function()
            {
                axios.get(this.$api_url+'/all-cost-center' , {
                    params: {
                    }
                }).then(function(response){
                    this.costcenters = response.data;

                    if(this.costcenters.length == 0)
                        this.blankmsg = "Nothing found.";

                }.bind(this));
            },

        },
        created: function(){
            if(this.$cookies.isKey("report_column_selected"))
                {
                    if(this.$cookies.get("report_column_selected") != null && this.$cookies.get("report_column_selected") != '')
                    {
                        if(Array.isArray(this.$cookies.get("report_column_selected")))
                        {
                            this.column_selected = this.$cookies.get("report_column_selected");
                        }
                        else
                        {
                            this.column_selected = this.$cookies.get("report_column_selected").split(',');
                        }
                    }
                }

            //this.report_settings.extra_fields = [];
            this.getPayrollDefaultField();
            this.get_current_fiscal_year();
            this.getPayrollReporting();
            this.get_report_settings();
            this.getAllCostCenters();



        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.details;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            clickSelect()
            {
                var lt = this.column_selected_view.length;

                this.column_selected_view = this.column_selected;
                if(this.column_selected_view.length !=  lt)
                {
                    this.column_selected_view = this.column_selected;
                }

                // if(this.column_selected.indexOf('name') > -1){
                //     this.column_selected.splice('name', 1);
                // }
                this.show_selected = this.column_selected_view.join();
                this.show_selected = this.show_selected.replaceAll("_", " ");
                this.show_selected = this.show_selected.replaceAll(",", " , ");
                this.show_selected = this.capitalizeTheFirstLetterOfEachWord(this.show_selected);

                if(this.column_selected.length ==0)
                {
                    this.show_selected = 'None Selected';
                }

                this.$cookies.set("report_column_selected", this.column_selected,'24h');

            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>

<style>

.d-inline-block.trz_fields.trz-custom-dropdown.mb-1 button {
	position: relative !important;
	bottom: 0 !important;
}
</style>
